import { Calendar } from "@fullcalendar/core";
import dayGridPlugin from "@fullcalendar/daygrid";
import axios from "axios";
import { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  List,
  ListItem,
  IconButton,
  ListItemText,
  CircularProgress,
  Card,
  CardContent,
  Divider,
  Typography,
  Skeleton,
  Box,
  Tooltip,
  Paper,
  useTheme,
  TextField,
} from "@mui/material";

import {
  GridActionsCellItem,
  DataGrid,
  GridRowModes,
  GridToolbarContainer,
  GridRowEditStopReasons,
} from "@mui/x-data-grid";
import "./Calendar.css";
import CloseIcon from "@mui/icons-material/Close";
import MenuOutlinedIcon from "@mui/icons-material/MenuOutlined";
import PeopleAltIcon from "@mui/icons-material/PeopleAlt";
import { useProSidebar } from "react-pro-sidebar";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import {
  CalendarpostData,
  DashcalpostData,
} from "../../store/reducers/Formapireducer";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-hot-toast";
import { useNavigate } from "react-router-dom";
import {
  CheckinAutocomplete,
  Employeeautocomplete,
  MultiFormikOptimizedAutocomplete,
} from "../../ui-components/global/Autocomplete";
import { tokens } from "../../Theme";
import { weeklyclasscaledarGet } from "../../store/reducers/Explorelitviewapireducer";
const ClassCalendar = () => {
  const calendarRef = useRef(null);
  const calendarInstanceRef = useRef(null);
  const [eventsData, setEventsData] = useState([]);
  const [DialogData, setDialogData] = useState([]);
  const { toggleSidebar, broken, rtl } = useProSidebar();
  const [clickedDate, setClickedDate] = useState("");
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();
  const [dialogOpen, setDialogOpen] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [isTodayDialog, setIsTodayDialog] = useState(false);
  const [taskData, setTaskData] = useState([]);
  const [taskLoading, setTaskLoading] = useState(false);
  const [open, setOpen] = useState(false);
  const EMPID = sessionStorage.getItem("EmpId");
  const [currentDayTasks, setCurrentDayTasks] = useState([]);
  const [yesterdayTasks, setYesterdayTasks] = useState([]);
  const [backlogTasks, setBacklogTasks] = useState([]);
  const [blockedTasks, setBlockedTasks] = useState([]);

  const [activeTab, setActiveTab] = useState("todo"); // or 'approved'
  const [notApprovedTasks, setNotApprovedTasks] = useState([]);
  const [isToday, setIsToday] = useState(false);
  const isManager = sessionStorage.getItem("isManager");
  const companyClassification = sessionStorage.getItem("Classification");

  console.log(companyClassification, "--companyClassification");
  
  const calendardata = useSelector((state) => state.formApi.calendardata);
  const calenderEmpRecordID = useSelector(
    (state) => state.formApi.calenderEmpRecordID,
  );
  // const formatDate = (date) => {
  //   if (!date) return "";
  //   const d = new Date(date);
  //   return `${String(d.getDate()).padStart(2, "0")}-${String(d.getMonth() + 1).padStart(2, "0")}-${d.getFullYear()}`;
  // };
  const dispatch = useDispatch();

  const empID = sessionStorage.getItem("EmpId");
  const compID = sessionStorage.getItem("companyId");
  const listViewurl = useSelector((state) => state.globalurl.listViewurl);

  const theme = useTheme();
  const colors = tokens(theme.palette.mode);

  const [selectedStandard, setSelectedStandard] = useState(null);
  const [selectedTerms, setSelectedTerms] = useState(null);
  const [selectedSection, setSelectedSection] = useState(null);
  // const [selectedfromdate, setSelectedFromdate] = useState("");
  // const [selectedtodate, setSelectedtodate] = useState("");

  //   const formatDate = (date) => {
  //   const d = new Date(date);
  //   return d.toLocaleDateString("en-GB").split("/").join("-");
  // };

  const handleApply = () => {
    if (!selectedStandard || !selectedSection) {
      alert("Please select Standards and Sections");
      return;
    }
     const TermsID = selectedTerms ? selectedTerms.RecordID : "";
console.log(TermsID, "--TermsID");
console.log(selectedTerms, "--selectedTerms");
// return;
    dispatch(
      weeklyclasscaledarGet({
        projectID: selectedStandard?.RecordID || selectedStandard,
        milestonesID: selectedSection?.RecordID || selectedSection,
        // milestonesID: selectedSection?.map((i) => `${i.RecordID}`).join(","),
        TermsID: TermsID,
        CompanyID: compID
      }),
    );
  };

  const handleReset = () => {
    setSelectedStandard(null);
    setSelectedTerms(null);
    setSelectedSection(null);
    
  };

  const WCrows = useSelector((state) => state.exploreApi.explorerowData);
  const calendarData = useSelector((state) => state.exploreApi.Data);
// const breakSlots = calendarData?.BreakSlots || [];
// console.log(breakSlots, "--breakSlots");
const breakSlots = Array.isArray(calendarData?.BreakSlots)
  ? calendarData.BreakSlots
  : [];

  const WEEKcolumns = useSelector(
    (state) => state.exploreApi.explorecolumnData,
  );
  const WEEKloading = useSelector((state) => state.exploreApi.loading);
  console.log(WCrows, "--WCrows");
  console.log(WEEKcolumns, "--WEEKcolumns");
  console.log(WEEKloading, "--WEEKloading");

  return (
    <Paper
      elevation={3}
      sx={{
        width: "100%",
        p: 3,
        borderRadius: 3,
      }}
    >
      {/* ================= TITLE ROW ================= */}
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          // justifyContent: "space-between",
          mb: 3,
          flexWrap: "wrap",
          gap: 2,
          // small left margin
        }}
      >
        <Typography variant="h5" fontWeight="bold">
          Weekly TimeTable
        </Typography>

        {/* RIGHT SIDE - LOOKUPS + BUTTONS */}
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 2,
            flexWrap: "wrap",
            ml: 1,
          }}
        >
          {/* <TextField
            name="fromdate"
            type="date"
            label="From Date"
            variant="standard"
            focused
            value={selectedfromdate}
            onChange={(e) => setSelectedFromdate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: 200 }}
          />

          <TextField
            name="todate"
            type="date"
            label="To Date"
            variant="standard"
            focused
            value={selectedtodate}
            onChange={(e) => setSelectedtodate(e.target.value)}
            InputLabelProps={{ shrink: true }}
            sx={{ width: 200 }}
          /> */}
          
            <CheckinAutocomplete
       sx={{ width: 200 }}
                           name="Terms"
                           label={
                             <>
                               {/* Project */}
                              Term
                               <span style={{ color: "red", fontSize: "20px" }}>
                                 {" "}
                                 *{" "}
                               </span>
                             </>
                           }
                           id="Terms"
                           value={selectedTerms}
                          onChange={(newValue) => {
    setSelectedTerms(newValue);
  }}
                          //  error={!!touched.ProName && !!errors.ProName}
                          //  helperText={touched.ProName && errors.ProName}
                           url={`${listViewurl}?data={"Query":{"AccessID":"2155","ScreenName":"Terms","Filter":"","Any":""}}`}
                           // 2054
                         />
             <CheckinAutocomplete
       sx={{ width: 200 }}
                           name="ProName"
                           label={
                             <>
                               {/* Project */}
                               Standard
                               <span style={{ color: "red", fontSize: "20px" }}>
                                 {" "}
                                 *{" "}
                               </span>
                             </>
                           }
                           id="ProName"
                           value={selectedStandard}
                          onChange={(newValue) => {
    setSelectedStandard(newValue);
  }}
                          //  error={!!touched.ProName && !!errors.ProName}
                          //  helperText={touched.ProName && errors.ProName}
                           url={`${listViewurl}?data={"Query":{"AccessID":"2119","ScreenName":"Project","Filter":"parentID=${compID} AND EmployeeID=${EMPID}","Any":""}}`}
                           // 2054
                         />
          {/* <MultiFormikOptimizedAutocomplete
            sx={{ width: 200 }}
            name="ProName"
            label={
              <>
                Standards
                <span style={{ color: "red", fontSize: "20px" }}> *</span>
              </>
            }
            id="ProName"
            value={selectedStandard}
            onChange={(e, newValue) => setSelectedStandard(newValue)}
            url={`${listViewurl}?data={"Query":{"AccessID":"2119","ScreenName":"Project","Filter":"parentID=${compID} AND EmployeeID=${EMPID}","Any":""}}`}
          /> */}

          <CheckinAutocomplete
            sx={{ width: 200 }}
            name="Milestone"
            label={
              <>
                Section
                <span style={{ color: "red", fontSize: "20px" }}> * </span>
              </>
            }
            variant="outlined"
            id="Milestone"
            value={selectedSection}
            getOptionLabel={(option) => option?.Name || ""}
            // onChange={(e, newValue) => setSelectedSection(newValue)}
               onChange={(newValue) => {
    setSelectedSection(newValue);
  }}
            // onChange={(e, newValue) =>
            // setSelectedSection("Milestone", newValue)
            //                         }
            // url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"parentID IN(${selectedStandard?.map((i) => i.RecordID).join(",")}) AND CompanyID='${compID}'","Any":""}}`}

            //  value={values.Milestone}
            //  getOptionLabel={(option) => option?.Name || ""}
            //  onChange={(newValue) => {
            //    setFieldValue("Milestone", newValue);
            //  }}
             url={`${listViewurl}?data={"Query":{"AccessID":"2105","ScreenName":"Milestone","Filter":"parentID IN(${selectedStandard?.RecordID}) AND CompanyID='${compID}'","Any":""}}`}
          />

          <Button
            variant="contained"
            onClick={handleApply}
            sx={{
              backgroundColor: "#2e7c67",
              height: 35,
              "&:hover": {
                backgroundColor: "#256b59",
              },
              ml: 10
            }}
          >
            Apply
          </Button>

          <Button
            variant="contained"
            color="error"
            onClick={handleReset}
            sx={{ height: 35 }}
          >
            Reset
          </Button>
        </Box>
      </Box>

      <Box
        sx={{
          height: 358,
          width: "100%",

          // Remove outer default border if needed
          "& .MuiDataGrid-root": {
            border: "1px solid #ccc",
          },

          // Header styling
          "& .MuiDataGrid-columnHeaders": {
            backgroundColor: colors.greenAccent[900],
            color: "#111",
            borderBottom: "1px solid #ccc",
          },

          "& .MuiDataGrid-columnHeaderTitle": {
            fontWeight: 700,
            fontSize: "13px",
          },

          "& .MuiDataGrid-columnHeader": {
            borderRight: "1px solid #ccc",
          },

          // Body cell styling (Table look)
          "& .MuiDataGrid-cell": {
            borderRight: "1px solid #ccc",
            borderBottom: "1px solid #ccc",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            // py: 5,        // vertical padding
            // px: 4.5,      // horizontal padding
          },

          // Remove last column right border (optional clean look)
          "& .MuiDataGrid-columnHeader:last-of-type": {
            borderRight: "none",
          },
          "& .MuiDataGrid-cell:last-of-type": {
            borderRight: "none",
          },

          "& .MuiDataGrid-virtualScroller": {
            backgroundColor: "#fff",
          },
          "& .odd-row": {
            backgroundColor: "",
            color: "#111", // Color for odd rows
          },
          "& .even-row": {
            backgroundColor: "",
            color: "", // Color for even rows
          },
          "& .even-row:hover": {
            backgroundColor: "", // hover color
          },
        }}
      >
        <DataGrid
          rows={WCrows}
          columns={WEEKcolumns}
          loading={WEEKloading}
          pageSizeOptions={[5]}
          hideFooter
          disableRowSelectionOnClick
          rowHeight={50}
          getRowClassName={(params) =>
            params.indexRelativeToCurrentPage % 2 === 0 ? "even-row" : "odd-row"
          }
        />
      </Box>

      <Box
  sx={{
    mt: 2,
    borderTop: "1px solid #dcdcdc",
    pt: 2,
  }}
>
  <Typography
    sx={{
      fontWeight: 700,
      mb: 1.5,
      color: "#333",
    }}
  >
    Intervals
  </Typography>

  <Box
    sx={{
      display: "flex",
      gap: 2,
      flexWrap: "wrap",
    }}
  >
    {breakSlots.map((slot, index) => (
      <Box
        key={index}
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 1,
          px: 2,
          py: 0.8,
          borderRadius: "8px",
          background: colors.greenAccent[900],
          border: "1px solid #c8dedd",
          boxShadow: "0px 1px 3px rgba(0,0,0,0.08)",
        }}
      >
        {/* Slot Time */}
        <Typography
          sx={{
            fontWeight: 600,
            color: "#1f5f5b",
          }}
        >
          {slot.SlotText}
        </Typography>

        {/* Arrow */}
        <Typography
          sx={{
            fontWeight: 600,
            color: "#888",
          }}
        >
          →
        </Typography>

        {/* Break Name */}
        <Typography
          sx={{
            fontWeight: 700,
            color: "#2e7c67",
          }}
        >
          {slot.SlotName}
        </Typography>
      </Box>
    ))}
  </Box>
</Box>
    </Paper>
  );
};

export default ClassCalendar;
